import { axiosTnaGet } from "../api/apiAxios"
import { segRenewUrl } from "../api/apiUrl"
import { getAuth } from "../api/apiUtil"
import { useAuth } from "./useAuth"

export const useTokenTna = () => {
    const { setAuth } = useAuth()

    const refresh = async () => {
        const url = segRenewUrl()
        const [dat_api, err_api] = await axiosTnaGet(url)
        const tokenTna = dat_api?.token
        if (!err_api)
            setAuth(prev => { return { ...prev, tokenTna } })
        else
            setAuth({ ...getAuth(false), message: err_api?.message })
        return tokenTna
    }

    return refresh
}